import { store } from "../store";
import firebase from 'firebase/app';
import 'firebase/auth';

const DynamicAuthGuard = (to, from, next) => {
    const currentUser = firebase.auth().currentUser;  // Direct use of Firebase Auth
    if (!currentUser) {
        next('/login');  // Redirect to login if no user is logged in
        return;
    }
    const userRoles = store.state.user.fbuserdata?.roles ?? [];
    if (userRoles.includes('devAd')) {
        next(); // Automatically grant access if the user is a developer admin
        return;
    }


    // Retrieve the constant identifier from route meta
    const authIdentifier = to.matched.some(record => record.meta.authIdentifier) ? 
        to.meta.authIdentifier : null;

        // console.log(authIdentifier)

    if (!authIdentifier || !store.state.auth.permissions || !store.state.auth.permissions[authIdentifier]) {
        console.warn('Permissions data is not loaded yet or no permissions for this route');
        next('/loading'); // Redirect to a loading or retry page
        return;
    }

    const permissions = store.state.auth.permissions[authIdentifier];  // Retrieve permissions from Vuex
    // const permissions = store.getters['getPermissions'](authIdentifier);  // Using the getter
    // console.log(permissions)

    if (!permissions) {
        next('/unauthorized');  // Handle case where no permissions are defined for the route
        return;
    }

    // const userRoles = store.state.user.fbuserdata?.roles ?? [];
    const userId = currentUser.uid;

    // Check if user's roles or UID match the permissions stored in Vuex
    const hasRoleAccess = permissions.roles?.some(role => userRoles.includes(role));
    const hasUserAccess = permissions.specificUsers?.includes(userId);


    // Additional check for developer access
  const hasDevAccess = to.meta.devAccess?.some(role => userRoles.includes(role)) ?? false;

    if (hasRoleAccess || hasUserAccess || hasDevAccess) {
        next();  // User has the required access
    } else {
        next('/unauthorized');  // User does not have the required access
    }
};

export default DynamicAuthGuard;


//   const routeName = to.name;
//   // Ensure there is a permissions object in Vuex before accessing a property
//   if (!store.state.permissions || !store.state.permissions[routeName]) {
//     console.warn('Permissions data is not loaded yet or no permissions for this route');
//     next('/loading'); // Redirect to a loading or retry page
//     return;
//   }

//   const permissions = store.state.permissions[routeName];  // Retrieve permissions from Vuex